import React from 'react';
import './TeamsPage.css';

const TeamsPage = () => {
  return (
    <div className="teams-container">
      
      {/* 1. HERO SECTION */}
      <header className="teams-hero">
        <div className="hero-badge">CONSULTORÍA CORPORATIVA</div>
        <h1>Potencia tu Equipo de Exploración</h1>
        <div className="hero-underline"></div>
        
        <div className="hero-description">
          <p className="lead-text">
            <strong>Nuestro equipo está formado por Geólogos Senior, Ingenieros de Minas y Expertos en Data Science.</strong>
          </p>
          <p>
            Hemos capacitado a cientos de profesionales y optimizado flujos de trabajo en empresas mineras de primer nivel. 
            Sabemos que la implementación de nuevas tecnologías como Python o Machine Learning puede ser un desafío. 
            Nosotros cerramos esa brecha técnica.
          </p>
        </div>
      </header>

      {/* 2. ÁREAS DE EXPERTISE */}
      <section className="offerings-section">
        <h2 className="section-title">NUESTRAS ÁREAS DE EXPERTISE</h2>
        
        <div className="offerings-grid">
          
          {/* PILAR 1: GEOLOGÍA & RECURSOS (Sin Borde, Con Línea) */}
          <div className="offering-card highlight-card">
            <div className="card-icon">⚒️</div>
            <h3>Geología & Recursos Minerales</h3>
            <p className="card-intro">
              La consultoría técnica especializada es el puente entre los datos y las decisiones que crean valor. 
              Acompañamos a las empresas mineras para aprovechar la totalidad de sus datos geológicos, 
              transformándolos en información confiable y accionable.
            </p>
            
            {/* --- LÍNEA SEPARADORA NUEVA --- */}
            <div className="card-separator"></div>
            
            <h4>¿Qué hacemos?</h4>
            <p>
              Integramos conocimiento, método y tecnología. Analizamos cada componente con rigor técnico, 
              conectando los resultados en un flujo coherente que fortalece la interpretación del yacimiento y reduce la incertidumbre.
            </p>
            
            <ul className="offering-list">
              <li>Clasificación de recursos minerales.</li>
              <li>Simulación estocástica y Geoestadística.</li>
              <li>Modelamiento geológico 3D implícito.</li>
              <li>Evaluación de lotes mineros.</li>
              <li>Gestión y validación de bases de datos.</li>
            </ul>
            
            <div className="card-footer-text">
              "Nuestro enfoque convierte la complejidad en claridad, y los datos en una ventaja competitiva sostenida."
            </div>

            <a href="https://wa.me/51963462787?text=Hola,%20me%20interesa%20la%20consultor%C3%ADa%20en%20Geolog%C3%ADa" className="btn-action btn-green">
              COTIZAR SERVICIO GEOLÓGICO
            </a>
          </div>

          {/* PILAR 2: TECNOLOGÍA & DATA SCIENCE */}
          <div className="offering-card">
            <div className="card-icon">🤖</div>
            <h3>Tecnología & Automatización (IA)</h3>
            <p className="card-intro">
              Ayudamos a digitalizar flujos de trabajo manuales. Desde la captura de datos en campo 
              hasta la visualización en dashboards automatizados. Reducimos el tiempo de procesamiento 
              de datos geológicos en un 70% mediante algoritmos a medida.
            </p>
            
            <div className="card-separator"></div>

            <h4>Soluciones Tecnológicas</h4>
            <p>
              Desarrollamos herramientas personalizadas que se integran con tu software minero actual (Leapfrog, Datamine, Vulcan),
              potenciando la capacidad de análisis de tu equipo sin cambiar su flujo de trabajo.
            </p>

            <ul className="offering-list">
              <li>Scripts de validación QA/QC automatizados.</li>
              <li>Integración de bases de datos y Dashboards.</li>
              <li>Modelos predictivos con Machine Learning.</li>
              <li>Capacitación In-Company en Python aplicado.</li>
            </ul>

            <a href="https://wa.me/51963462787?text=Hola,%20me%20interesa%20la%20consultor%C3%ADa%20en%20Tecnolog%C3%ADa" className="btn-action btn-outline">
              AGENDAR DIAGNÓSTICO TECNOLÓGICO
            </a>
          </div>

        </div>
      </section>

      {/* 3. COMING SOON */}
      <section className="coming-soon-section">
        <div className="coming-soon-content">
          <h2>AUDITORÍA DE BASE DE DATOS (PRÓXIMAMENTE)</h2>
          <p className="coming-soon-subtitle">
            El código definitivo para equipos que buscan escalar sus operaciones.
          </p>
          <p>
            Estamos desarrollando un servicio de auditoría profunda para limpiar, estructurar 
            y validar años de data histórica minera utilizando algoritmos de Inteligencia Artificial.
          </p>
          <ul className="coming-soon-list">
            <li>Detección automática de anomalías en leyes.</li>
            <li>Estandarización de litologías.</li>
            <li>Recuperación de valor de data antigua.</li>
          </ul>
          
          {/* BOTÓN CON LINK A WHATSAPP */}
          <a 
            href="https://wa.me/51963462787?text=Hola,%20me%20interesa%20la%20Auditor%C3%ADa%20de%20Base%20de%20Datos%20con%20IA.%20Por%20favor%20av%C3%ADsame%20cuando%20est%C3%A9%20disponible." 
            target="_blank" 
            rel="noopener noreferrer" 
            className="btn-action btn-blue"
          >
            AVÍSAME CUANDO ESTÉ LISTO
          </a>
          
        </div>
        <div className="coming-soon-image">
          <img 
            src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=800&auto=format&fit=crop" 
            alt="Dashboard Minero" 
          />
        </div>
      </section>

      {/* 4. CONTACTO DOBLE */}
      <section className="get-in-touch">
        <h2 className="section-title">HABLEMOS CON LOS EXPERTOS</h2>
        <p className="contact-intro">¿Tienes dudas técnicas? Conversa directamente con nuestros consultores senior.</p>
        
        <div className="founders-grid">
          
          {/* PERFIL 1: MIKE */}
          <div className="founder-card">
            <img src="/images/mike.jpg" alt="Ing. Mike" className="profile-pic" />
            <h3>Ing. Mike</h3>
            <div className="badge-consultant">Consultor Data Science & Minería</div>
            <p>
              Especialista en automatización de procesos, Machine Learning aplicado a la industria y desarrollo de software minero.
            </p>
            <a href="https://wa.me/51963462787?text=Hola%20Mike,%20quisiera%20consultar%20sobre%20servicios%20de%20data..." className="btn-action btn-green-small">
              CONTACTAR A MIKE <i className="fab fa-whatsapp"></i>
            </a>
          </div>

          {/* PERFIL 2: DEMIAN */}
          <div className="founder-card">
            <img src="/images/demian.jpg" alt="Ing. Demian" className="profile-pic" />
            <h3>Ing. Demian Gide</h3>
            <div className="badge-consultant">Consultor Geología & Modelamiento</div>
            <p>
              Experto en Leapfrog, modelamiento implícito, geología estructural y optimización de recursos minerales.
            </p>
            <a href="https://wa.me/51963462787?text=Hola%20Demian,%20quisiera%20consultar%20sobre%20servicios%20de%20geolog%C3%ADa..." className="btn-action btn-green-small">
              CONTACTAR A DEMIAN <i className="fab fa-whatsapp"></i>
            </a>
          </div>

        </div>
      </section>

    </div>
  );
};

export default TeamsPage;